import {Injectable, Type} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {ModalComponent} from "./modal.component";
import {Options} from '../../interfaces/modal';
import {DeteccionCambiosService} from "../../../../infrastructure/services/deteccion-cambios.service";

@Injectable({
  providedIn: 'root'
})


export class ModalService {

  private isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$ = this.isOpenSubject.asObservable();

  private _loadComponent = new Subject<Type<any>>();
  public componentToLoad$ = this._loadComponent.asObservable();
  private modalComponentRef!: ModalComponent;
  private _onDidDismiss = new Subject<any>();
  public onDidDismiss$ = this._onDidDismiss.asObservable();
  public primaryButtonAction: () => void = () => {};
  // Guarda del nivel abierto para Esc y Cancelar: devuelve false si el modal prefiere
  // preguntar antes de perder cambios (y se encarga él de cerrar si se confirma).
  private antesDeDescartar: (() => boolean) | null = null;
  // Niveles apilados cuando un modal abre otro (p. ej. "Mejorar con IA" desde
  // crear-agente): al cerrar el hijo se restaura el padre con su estado intacto.
  private niveles: {
    titulo: string;
    primaryButtonAction: () => void;
    antesDeDescartar: (() => boolean) | null;
    dismissSubject: Subject<any>;
  }[] = [];

  public get isOpenValue(): boolean {
    return this.isOpenSubject.value;
  }

  constructor(private detectaUIService: DeteccionCambiosService) {

  }

  public setTitulo(titulo: string): void {
    this.modalComponentRef.titulo = titulo;
    this.detectaUIService.setActualizaUI();
  }

  public setModalComponentRef(ref: ModalComponent): void {
    this.modalComponentRef = ref;
    this.detectaUIService.setActualizaUI();
  }

  public setPrimaryButtonAction(action: () => void): void {
    this.primaryButtonAction = action;
  }

  public setAntesDeDescartar(guarda: (() => boolean) | null): void {
    this.antesDeDescartar = guarda;
  }

  /** Cierre que pide la persona (Esc, Cancelar): pasa antes por la guarda del nivel. */
  public descartar(): void {
    if (this.antesDeDescartar !== null && !this.antesDeDescartar()) {
      return;
    }
    this.dismiss();
  }

  public open() {
    this.isOpenSubject.next(true);
    this.detectaUIService.setActualizaUI();
  }

  public close(data: any = true) {
    this.cerrarNivelActual(data);
  }

  public dismiss() {
    this.cerrarNivelActual(false);
  }

  private cerrarNivelActual(data: any): void {
    const dismissActual = this._onDidDismiss;
    const nivelAnterior = this.niveles.pop();

    if (nivelAnterior && this.modalComponentRef?.restorePrevious()) {
      this.modalComponentRef.titulo = nivelAnterior.titulo;
      this.primaryButtonAction = nivelAnterior.primaryButtonAction;
      this.antesDeDescartar = nivelAnterior.antesDeDescartar;
      this._onDidDismiss = nivelAnterior.dismissSubject;
      this.onDidDismiss$ = this._onDidDismiss.asObservable();
    } else {
      this.isOpenSubject.next(false);
      this.primaryButtonAction = () => undefined;
      this.antesDeDescartar = null;
    }

    dismissActual.next(data);
    this.detectaUIService.setActualizaUI();
  }

  public toggle() {
    this.isOpenSubject.next(!this.isOpenSubject.value);
  }

  public loadComponent(component: Type<any>, options?: Options) {
    if (this.isOpenSubject.value) {
      this.niveles.push({
        titulo: this.modalComponentRef.titulo,
        primaryButtonAction: this.primaryButtonAction,
        antesDeDescartar: this.antesDeDescartar,
        dismissSubject: this._onDidDismiss,
      });
      this.primaryButtonAction = () => undefined;
    } else {
      this.niveles = [];
    }
    this.antesDeDescartar = null;

    this.setTitulo('');
    this._onDidDismiss = new Subject<any>();
    this.onDidDismiss$ = this._onDidDismiss.asObservable();
    this.detectaUIService.setActualizaUI();
    return this.modalComponentRef.loadComponent(component, options);
  }
}
